import { render } from "./GroupsSlideOverComponent.vue?vue&type=template&id=29de7e36"
import script from "./GroupsSlideOverComponent.vue?vue&type=script&lang=js"
export * from "./GroupsSlideOverComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__